export class CreditIssuance {
  amount: number;

  constructor(creditIssuance?: any) {
    if (creditIssuance) {
      Object.assign(this, creditIssuance);
    } else {
      this.amount = null;
    }
  }
}
